import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': 'Bahasa Indonesia',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'Batal',
  'smarthr-ui/AppHeader/school': 'SmartHR School',
  'smarthr-ui/AppHeader/help': 'Bantuan',
  'smarthr-ui/AppHeader/userSettings': 'Pengaturan pribadi',
  'smarthr-ui/AppHeader/releaseNotes': 'Release note',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'Gagal memuat release note.\nSilakan coba beberapa saat lagi.',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'Lihat semua release note',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'Aplikasi',
  'smarthr-ui/AppHeader/MobileHeader/account': 'Akun',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'Buka menu',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'Tutup menu',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': 'Semua aplikasi',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': 'Menu pengelolaan',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': 'Release note terkini',
  'smarthr-ui/AppHeader/MobileHeader/back': 'Kembali',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': 'Buka',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': 'Tutup',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'Masukkan nama aplikasi.',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'Aplikasi yang sering digunakan',
  'smarthr-ui/AppHeader/Launcher/allModeText': 'Semua aplikasi',
  'smarthr-ui/AppHeader/Launcher/listText': 'Daftar aplikasi',
  'smarthr-ui/AppHeader/Launcher/helpText': 'Tentang aplikasi yang sering digunakan',
  'smarthr-ui/AppHeader/Launcher/searchResultText': 'Hasil penelusuran',
  'smarthr-ui/AppHeader/Launcher/emptyText': 'Tidak ditemukan aplikasi yang sesuai.',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': 'Urutkan berdasarkan',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': 'Dipilih',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': 'Default',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'Urutkan nama aplikasi A-Z',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'Urutkan nama aplikasi Z-A',
  'smarthr-ui/AppLauncher/showAllText': 'Lihat semua',
  'smarthr-ui/AppLauncher/triggerLabel': 'Aplikasi',
  'smarthr-ui/Browser/notFoundDescription': 'Silakan coba dengan kriteria lain.',
  'smarthr-ui/Browser/notFoundTitle': 'Tidak ada item yang sesuai.',
  'smarthr-ui/Button/loading': 'Sedang diproses',
  'smarthr-ui/Calendar/currentYear': 'Tahun saat ini',
  'smarthr-ui/Calendar/nextMonth': 'Ke bulan berikutnya',
  'smarthr-ui/Calendar/previousMonth': 'Ke bulan sebelumnya',
  'smarthr-ui/Calendar/selectYear': 'Pilih tahun',
  'smarthr-ui/Combobox/addItemButtonLabel': 'Tambah “{name}”',
  'smarthr-ui/Combobox/loadingText': 'Sedang diproses',
  'smarthr-ui/Combobox/noResultsText': 'Tidak ada pilihan yang sesuai.',
  'smarthr-ui/DropdownMenuButton/triggerActive': 'Tutup pilihan',
  'smarthr-ui/DropdownMenuButton/triggerInactive': 'Buka pilihan',
  'smarthr-ui/DropZone/selectButtonLabel': 'Pilih file',
  'smarthr-ui/FileViewer/rotateAlt': 'Putar ke kiri',
  'smarthr-ui/FileViewer/scaleDownAlt': 'Perkecil',
  'smarthr-ui/FileViewer/scaleRateLabel': 'Skala pembesaran',
  'smarthr-ui/FileViewer/scaleUpAlt': 'Perbesar',
  'smarthr-ui/FileViewer/unsupportedFileText': 'Format file tidak didukung.',
  'smarthr-ui/FilterDropdown/applyText': 'Terapkan',
  'smarthr-ui/FilterDropdown/cancelText': 'Batal',
  'smarthr-ui/FilterDropdown/resetText': 'Hapus kriteria filter',
  'smarthr-ui/FilterDropdown/status': 'Diterapkan',
  'smarthr-ui/FilterDropdown/triggerText': 'Filter',
  'smarthr-ui/FormDialog/closeButtonLabel': 'Batal',
  'smarthr-ui/InformationPanel/closeButtonLabel': 'Tutup',
  'smarthr-ui/InformationPanel/openButtonLabel': 'Buka',
  'smarthr-ui/InputFile/destroy': 'Hapus',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': 'Dipilih',
  'smarthr-ui/Loader/alt': 'Sedang diproses',
  'smarthr-ui/MessageDialog/closeButtonLabel': 'Tutup',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': 'Tutup',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'Posisi dialog',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'Dapat diseret',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': 'Tekan tombol panah untuk menavigasi ke atas, bawah, kiri, dan kanan.',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '{top} px dari atas, {left} px dari kiri',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': ': hapus',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': 'Item yang dipilih',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': 'Tutup',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': 'Ke halaman pertama',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': 'Ke halaman terakhir',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': 'Selanjutnya',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': 'Sebelumnya',
  'smarthr-ui/Pagination/itemButtonLabel': 'Halaman {page}',
  'smarthr-ui/Pagination/navigationLabel': 'Navigasi halaman',
  'smarthr-ui/RequiredLabel/text': 'Wajib',
  'smarthr-ui/SearchInput/iconAlt': 'Cari',
  'smarthr-ui/SideMenu/navigationLabel': 'Menu samping',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'Bersihkan',
  'smarthr-ui/SortDropdown/applyText': 'Terapkan',
  'smarthr-ui/SortDropdown/ascLabel': 'Urutan naik',
  'smarthr-ui/SortDropdown/cancelText': 'Batal',
  'smarthr-ui/SortDropdown/descLabel': 'Urutan turun',
  'smarthr-ui/SortDropdown/sortFieldLabel': 'Kriteria pengurutan',
  'smarthr-ui/SortDropdown/sortOrderLegend': 'Urutan',
  'smarthr-ui/StepFormDialog/backButtonLabel': 'Kembali',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'Batal',
  'smarthr-ui/StepFormDialog/nextButtonLabel': 'Selanjutnya',
  'smarthr-ui/StepStatusIcon/closedAlt': 'Terhenti',
  'smarthr-ui/StepStatusIcon/completedAlt': 'Selesai',
  'smarthr-ui/Textarea/availableLetters': 'Sisa {availableLetters} karakter',
  'smarthr-ui/Textarea/maxLettersExceeded': 'Melebihi {exceededLetters} karakter',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': 'Maksimal {maxLetters} karakter',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': 'Buka di tab baru',
  'smarthr-ui/Th/sortDirectionAsc': 'Urutan naik',
  'smarthr-ui/Th/sortDirectionDesc': 'Urutan turun',
  'smarthr-ui/Th/sortDirectionNone': 'Tanpa pengurutan',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'Pilih/hapus semua item',
  'smarthr-ui/ThCheckbox/checkColumnName': 'Pilih',
} as const satisfies Record<keyof typeof ja, string>
